module.exports = __webpack_public_path__ + "indicator-1.png?80a55df848c708302b8243a304dd0ff3";